import mbxClient from '@mapbox/mapbox-sdk';

export default mbxClient({
    accessToken: 'pk.eyJ1Ijoiam9idG9vbHoiLCJhIjoiY2ptdnVlM3ZzMzFqZDNwb2V3cjAyOWNxMiJ9.WJzemW29rU956AEHWmbyKQ'
});
